import api from "../../index";

export const AddUpdateFormInformationApi = (data) => api.post('addupdateforminformation', data);
export const FormInformationListApi = () => api.post('forminformationlist');
export const AddUpdateCellInformationApi = (data) => api.post('addupdatecellinformation', data);
export const CellInformationListApi = () => api.post('cellinformationlist');
export const DeleteCellInformationApi = (data) => api.post('deletecellinformation', data);
export const DeleteFormInformationApi = (data) => api.post('deleteforminformation', data);